'use strict';
import googleMapLoader from 'google-map-react/lib/utils/loaders/google_map_loader';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/timeoutWith';
import {LRU} from 'lru-node-cache';
import {GOOGLE_MAPS_KEY} from '../../config/constants';

// TODO: remove once replaced with api keys epic
const gapiConfig = {
  key: GOOGLE_MAPS_KEY,
};

const geoCache = new LRU(200);

let geocoder;

export const NO_RESULTS = 'No Results';

/**
 * @param {Number} lat
 * @param {Number} lon
 * @param {Number} [timeout=90000] Timeout after 90 seconds by default.
 * @returns {Observable<String>}
 */
export function reverseGeoCode(lat, lon, timeout = 90000) {
  return Observable.fromPromise(geocoder
    ? getLocation(geocoder, lat, lon)
    : googleMapLoader(gapiConfig).then(maps => {
      geocoder = new maps.Geocoder();
      return getLocation(geocoder, lat, lon);
    }))
    .timeoutWith(timeout, Observable.throw(NO_RESULTS));
}

/**
 * @param {google.maps.Geocoder} geocoder
 * @param {Number} lat
 * @param {Number} lon
 * @returns {Promise<String>}
 */
function getLocation(geocoder, lat, lon) {
  return new Promise((resolve, reject) => {
    let isCached = false;
    const cacheKey = buildCacheKey(lat, lon);
    const cachedVal = geoCache.get(cacheKey);
    if (cachedVal) {
      handleResult(cachedVal.results, cachedVal.status);
    } else {
      geocoder.geocode( {'location': {lat, lng: lon}}, handleResult);
    }

    function handleResult(results, status) {
      if (!isCached) {
        isCached = true;
        geoCache.set(cacheKey, {results, status});
      }

      switch (status) {
        case 'OK':
          if (results && results[0] && results[0].formatted_address) {
            resolve(results[0].formatted_address);
          } else {
            reject(NO_RESULTS);
          }
          break;

        case 'ZERO_RESULTS':
          reject(NO_RESULTS);
          break;

        default:
          reject(status);
      }
    }
  });
}

function buildCacheKey(lat, lng) {
  return `${lat}, ${lng}`;
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/geo/GeoCoder.js